const employees = {
  headerButtons: {
    create: {
      createBtn: 'Criar',
    },
  },

  edit: {
    tabs: {
      information: 'Informação',
      history: 'Histórico',
      bookingHistory: 'Histórico de reservas',
    }
  },

  table: {
    headers: {
      createBtn: 'Criar',
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      homeAddress: 'Endereço de casa',
      workAddress: 'Endereço do trabalho',
      createdAt: 'Criado em',
      createdBy: 'Criado por',
    },
  },
  form: {
    header: {
      create: {
        title: 'Criar',
      },

      update: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    actions: {
      header: 'Ações',
      buttons: {
        resetPassword: 'Redefinir Senha',
      },
    },

    sections: {
      profiles: {
        header: 'Perfis',
        fields: {
          profiles: {
            label: 'Perfis',
          },
          attributes: {
            label: 'Atributos'
          }
        },
      },
      personalDetails: {
        header: 'Detalhes pessoais',
        fields: {
          firstName: {
            label: 'Nome',
          },
          lastName: {
            label: 'Sobrenome',
          },
          email: {
            label: 'E-mail',
          },
          phone: {
            label: 'Telefone',
          },
          additionalPhone: {
            label: 'Telefone adicional',
          },
        },
      },
      addresses: {
        header: 'Endereços de funcionários',
        fields: {
          workAddress: {
            label: 'Endereço do trabalho',
          },
          homeAddress: {
            label: 'Endereço de casa',
          },
          additionalHomeAddress: {
            label: 'Endereço Residencial 2',
          },
        },
      },
    },
  },

  create: {
    confirmButtonText: 'Enviar',
    toasts: {
      success: 'Selecionar Funcionários',
      error: 'Ocorreu um erro ao criar o principal',
    },
  },
  update: {
    activeStatus: {
      statusActive: 'Ativo',
      statusDeactivate: 'Inativa',
    },

    suspend: {
      actionActivate: 'Reativar',
      actionDeactivate: 'Suspender',
      suspendModal: {
        popupTitleDeactivation: 'Suspender passageiro',
        popupTitleActive: 'Motivo de Suspensão',
        popupTitleUnsuspend: 'Motivo de Anular a Suspensão',
        popupSubTitleDeactivation: 'Selecione o motivo da suspensão',
        popupActionActive: 'Reativar Passageiro',
        popupActionDeactivate: 'Suspender passageiro',
      },
    },
    toasts: {
      success: 'Principal atualizado com sucesso',
      error: 'Ocorreu um erro ao atualizar a principal',
      fetchError: 'Ocorreu um erro, por favor, tente novamente.',
    },
  },
};

export default employees;
